<div *ngIf="fullScreen(); else strip" class="xp-gallery__mask" role="dialog" aria-modal="true" cdkTrapFocus>
	<button #closeButton
	        type="button"
	        class="xp-gallery__close"
	        [attr.aria-label]="closeLabel()"
	        (click)="closed.emit()">
		<mat-icon class="xp-gallery__close-icon">close</mat-icon>
	</button>
	<div class="xp-gallery__content" @xpGalleryOpen>
		<ng-container *ngTemplateOutlet="stage"></ng-container>
	</div>
</div>

<ng-template #strip>
	<ng-container *ngTemplateOutlet="stage"></ng-container>
	<div *ngIf="thumbnailTemplate() as thumbnail" class="xp-gallery__thumbnails">
		<button type="button"
		        class="xp-gallery__nav"
		        [disabled]="navDisabled()"
		        [attr.aria-label]="previousLabel()"
		        (click)="previous()">
			<mat-icon>chevron_left</mat-icon>
		</button>
		<div class="xp-gallery__viewport">
			<div class="xp-gallery__track"
			     [class.xp-gallery__track--moving]="moving()"
			     [style.transform]="trackTransform()"
			     (transitionend)="onTrackTransitionEnd($event)"
			     (focusout)="onThumbnailsFocusOut($event)">
				<div *ngFor="let item of items(); let i = index"
				     class="xp-gallery__thumbnail"
				     [class.xp-gallery__thumbnail--current]="i === activeIndex()"
				     [class.xp-gallery__thumbnail--hidden]="!moving() && !isInView(i)"
				     [style.flex-basis.%]="100 / placeCount()">
					<button #thumbnailButton
					        type="button"
					        class="xp-gallery__thumbnail-button"
					        [attr.tabindex]="i === tabbableIndex() ? 0 : -1"
					        [attr.aria-label]="'Page ' + (i + 1)"
					        [attr.aria-current]="i === activeIndex() ? 'page' : null"
					        (click)="select(i)"
					        (keydown)="onThumbnailKeydown($event, i)">
						<ng-container *ngTemplateOutlet="thumbnail.templateRef; context: { $implicit: item }"></ng-container>
					</button>
				</div>
			</div>
		</div>
		<button type="button"
		        class="xp-gallery__nav"
		        [disabled]="navDisabled()"
		        [attr.aria-label]="nextLabel()"
		        (click)="next()">
			<mat-icon>chevron_right</mat-icon>
		</button>
	</div>
</ng-template>

<ng-template #stage>
	<div *ngIf="itemTemplate() || captionTemplate()" class="xp-gallery__stage">
		<div *ngIf="itemTemplate() as item" class="xp-gallery__item">
			<ng-container *ngIf="hasActiveItem()">
				<ng-container *ngTemplateOutlet="item.templateRef; context: { $implicit: activeItem() }"></ng-container>
			</ng-container>
		</div>
		<div *ngIf="hasActiveItem() && captionTemplate() as caption" class="xp-gallery__caption">
			<ng-container *ngTemplateOutlet="caption.templateRef; context: { $implicit: activeItem() }"></ng-container>
		</div>
	</div>
</ng-template>
